module.exports = "<ngb-carousel>\r\n    <ng-template ngbSlide *ngFor=\"let slide of data; let i = index\">\r\n\r\n      <img [src]=\"slide.imagen\" [alt]=\"slide.descripcion\" class=\"img-fluid\" style=\"width: 180vh; height: 50vh\">\r\n      <div class=\"carousel-caption\">\r\n      </div>\r\n    </ng-template>\r\n  </ngb-carousel>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/slider/slider.component.html
// module id = ./src/app/shared/components/slider/slider.component.html
// module chunks = main